import {css} from "lit";

// Note that we don't use variables in some places because these are ProQuest colors/styles.

export default [css`
	button {
		display: flex;
		width: 100%;
		gap: 10px;
		padding: 10px 5px;
		margin-top: 10px;
		align-items: center;
		text-align: left;
		background-color: rgba(242, 242, 242, 0.992);
		border: 0;
		border-radius: 0 0 5px 5px;
		border-top: 3px solid var(--pn-color-yellow);
		cursor: pointer;
	}

	button.is-pdf {
		width: auto;
		background: none;
		border-radius: 0;
	}

	img {
		width: 40px;
		height: 40px;
	}

	span {
		font-family: "Roboto", sans-serif;
		font-weight: 400;
		font-size: 20px;
		color: #585858;
	}

	button:hover, button:focus, button:active {
		background-color: rgb(215, 215, 215);
	}

	button:hover span, button:focus span, button:active span {
		color: rgb(51, 51, 51);
	}
`];
